<template>
  <v-list class="no-print">
    <template v-for="(item, index) in items">
      <v-divider v-if="item.divider" :key="index"></v-divider>
      <v-list-item
        v-if="item.visible !== false && !item.divider"
        :key="item.text"
        :to="item.to"
        :disabled="item.disabled"
        :inactive="item.disabled"
      >
        <v-list-item-action>
          <v-badge
            v-if="item.notificacoes || (item.badge && $store.state.rodada.id)"
            bordered
            dot
            color="error"
            :content="item.notificacoes || ''"
            :value="item.notificacoes"
            overlap
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-badge>

          <v-icon v-else>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtext }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list-item href="/chrome/ChromeStandaloneSetup.exe" v-if="!isChrome">
      <v-list-item-action>
        <v-icon>mdi-google-chrome</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Google Chrome</v-list-item-title>
        <v-list-item-subtitle>Download</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "menu-administrador",

  computed: {
    isChrome() {
      return (
        navigator.userAgent.match(/edg/i) ||
        navigator.userAgent.match(/chrome|chromium|crios/i)
      );
    },
    items() {
      return [
        {
          text: "Página Inicial",
          icon: "mdi-chart-areaspline",
          to: "/dashboard",
          disabled: false,
          visible: !!this.$store.state.rodada.id,
        },
        { text: "Loja", icon: "mdi-storefront", to: "/", disabled: false },
        {
          text: "Notificações",
          icon: "notifications",
          to: "/notificacoes",
          disabled: true,
        },
        {
          text: "Rodadas de Negócio",
          icon: "mdi-bullseye",
          to: "/rodadas",
          disabled: false,
          badge: true,
        },
        {
          text: "Mapa dos Stands",
          icon: "mdi-map",
          to: `/mapa-stands/${this.$store.state.rodada.id}`,
          disabled: false,
          badge: false,
          visible: !!this.$store.state.rodada.id,
        },
        // {
        //   text: "Agenda",
        //   subtext: "Rodadas de Negócio",
        //   icon: "mdi-rhombus-split",
        //   to: "/agenda",
        //   disabled: false,
        // },
        { text: "Clientes", icon: "group", to: "/clientes", disabled: false },
        {
          text: "Fornecedores",
          icon: "people_outline",
          to: "/fornecedores",
          disabled: false,
        },
        {
          text: "Representantes",
          icon: "work",
          to: "/representantes",
          disabled: false,
        },
        {
          text: "Pedidos",
          icon: "description",
          to: "/pedidos",
          disabled: false,
          visible: !!this.$store.state.rodada.id,
        },
        { divider: true },
        {
          text: "Relatórios",
          icon: "list_alt",
          to: "/relatorios",
          disabled: false,
          visible: !!this.$store.state.rodada.id,
        },
        {
          text: "Ajuda",
          icon: "help",
          to: "/ajuda",
          disabled: true,
          visible: false,
        },
      ];
    },
  },
};
</script>

<style lang="css" scoped>
@media print {
  .no-print,
  .no-print * {
    display: none !important;
  }
}
</style>
